import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@insights-ltd/design-library/components';

export type ErrorFeedbackDialogProps = {
  open: boolean;
  onClose: () => void;
};

const ErrorFeedbackDialog = ({ open, onClose }: ErrorFeedbackDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-description"
      open={open}
      onClose={onClose}
      title={t('ui.event-management.events.download-profiles.error')}
      content={
        <DialogContentText
          id="error-dialog-description"
          color="textSecondary"
          variant="body1"
        >
          {t('ui.event-management.events.download-profiles.error-body')}
        </DialogContentText>
      }
      secondaryButtonText={t(
        'ui.event-management.events.download-profiles.error-ok',
      )}
    />
  );
};

export default ErrorFeedbackDialog;
